import { SpanStatusCode, trace, type Span } from "@opentelemetry/api"

const TRACER_NAME = "pleasur-ai"

function getTracer() {
  return trace.getTracer(TRACER_NAME)
}

function recordSpanError(span: Span, err: unknown): void {
  span.recordException(err instanceof Error ? err : new Error(String(err)))
  span.setStatus({ code: SpanStatusCode.ERROR, message: String(err) })
}

function resolveHttpStatus(result: unknown): number | undefined {
  if (!result || typeof result !== "object" || !("status" in result)) return undefined
  const status = (result as { status: unknown }).status
  return typeof status === "number" ? status : undefined
}

export async function tracedJob<T>(
  jobName: string,
  fn: () => Promise<T>
): Promise<T> {
  return getTracer().startActiveSpan(`job.${jobName}`, async (span) => {
    try {
      const result = await fn()
      const httpStatus = resolveHttpStatus(result)
      if (httpStatus !== undefined && httpStatus >= 400) {
        span.setStatus({
          code: SpanStatusCode.ERROR,
          message: `HTTP ${httpStatus}`,
        })
      } else {
        span.setStatus({ code: SpanStatusCode.OK })
      }
      return result
    } catch (err) {
      recordSpanError(span, err)
      throw err
    } finally {
      span.end()
    }
  })
}

export async function tracedSupabaseFetch<T>(
  operationName: string,
  attributes: Record<string, string | number | boolean>,
  fn: (span: Span) => Promise<T>
): Promise<T> {
  return getTracer().startActiveSpan(`supabase.${operationName}`, async (span) => {
    for (const [key, value] of Object.entries(attributes)) {
      span.setAttribute(key, value)
    }
    try {
      return await fn(span)
    } catch (err) {
      recordSpanError(span, err)
      throw err
    } finally {
      span.end()
    }
  })
}
